import _objectSpread from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.link.js";
import "core-js/modules/web.dom-collections.for-each.js";
import YYImage from "@/pages/design/components/basic/image";
import ProductListSlider from "@/pages/design/components/ProductListSlider.vue";
import { designGetProductList } from "@/services/design";
import { mapState } from "vuex";
export default {
  name: "pcgoodslist",
  components: {
    YYImage: YYImage,
    ProductListSlider: ProductListSlider
  },
  props: {
    formData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    id: {
      type: [Number, String],
      default: 0
    }
  },
  data: function data() {
    return {
      defaultLangId: 0,
      value: undefined
    };
  },
  watch: {},
  created: function created() {
    var defaultLangObjStr = window.localStorage.cdefaultLangObj ? window.localStorage.cdefaultLangObj : window.localStorage.defaultLangObj;
    var defaultLangObj = JSON.parse(defaultLangObjStr);
    // let defaultLangObj = JSON.parse(localStorage.defaultLangObj);
    if (defaultLangObj) {
      this.defaultLangId = defaultLangObj.langId;
    }

    /*
    进来productList 为空 -> 请求
    进来productList 有数据 -> 不请求
    如果商品列表有数据  就不请求
    如果请求因为网络慢 productList赋值比较晚
    又在配置页面添加了数据  这时productList是有数据的
    有数据 就添加在后面
    切换语言导致的有数据 会一进来就有数据 那么就不请求了
       */

    // if (this.formData.productList.length == 0){
    //   this.getProductList();
    // }

    // this.getProductList();
  },
  mounted: function mounted() {},
  computed: _objectSpread(_objectSpread({}, mapState({
    imgHost: function imgHost(state) {
      return state.design.imgHost;
    }
  })), {}, {
    moduleData: function moduleData() {
      var _this = this;
      // banner
      var tempBanner = [];
      // 18 为 banner之间的padding
      var padding = parseInt(this.formData.pcBannerSpace);
      var bannerWidth = (1200 - (this.formData.pcHorizontalPadding || 0) * 2 - padding * (this.formData.pcBannerSizeNum - 1)) / this.formData.pcBannerSizeNum;
      this.formData.pathlink.forEach(function (item) {
        tempBanner.push({
          style: {
            // 'background-image': 'url("'+ (this.imgHost + item.path) +'")',
            width: bannerWidth - padding + "px"
          },
          imgpath: item.path,
          styleSmall: {
            "background-image": 'url("' + item.path + '")',
            width: bannerWidth - padding * 2 + "px",
            height: _this.formData.pcBannerHeight + "px"
          },
          height: _this.formData.pcBannerHeight + "px",
          link: item.link,
          padding: padding / 2 + "px",
          outWidth: bannerWidth + "px"
        });
      });
      var arr = [];
      while (tempBanner.length > 0) {
        arr.push(tempBanner.splice(0, this.formData.pcBannerSizeNum));
      }
      return arr;
    }
  }),
  methods: {
    goToPage: function goToPage() {},
    getProductList: function getProductList() {
      var _this2 = this;
      designGetProductList({
        moduleId: this.id,
        langId: this.defaultLangId,
        plate: 2,
        clentType: 1
      }).then(function (res) {
        return res.data;
      }).then(function (res) {
        // //
        // let arr = []
        // if (this.formData.addedProduct && this.formData.addedProduct.length > 0){
        //   arr = [...this.formData.addedProduct, ...res.data.productList]
        // }else {
        //   arr = res.data.productList
        // }

        // this.$set(this.formData, "productList", arr);
        _this2.$set(_this2.formData, "productList", res.data.productList);
      }).catch(function (err) {
        console.log(' getProductList err', err);
        _this2.$set(_this2.formData, "productList", []);
      });
    }
  }
};